import { Stack, Typography } from "@mui/material";
import moment from "moment";
import { IHostEvent } from "services/models/Host";
import MailIcon from "@mui/icons-material/Mail";
import { useHostEvents } from "services/api/SWRService";
import { GridColDef } from "@mui/x-data-grid-pro";
import { dateCol } from "utils/datagrid-utils";
import { GridPaginationProps } from "../helpers";
import { SWRDataGrid } from "../SWRDataGrid";
import { Outlet, useNavigate } from "react-router-dom";
import Routes from "constants/routes";
import { FromLocation } from "../EventsAndPromotions";
import { filterPanelSx } from "..";
import { useMobile } from "hooks/Mobile/useMobile";
import { SMTooltip } from "components/lib/SMTooltip";

type Prop = {
  from: FromLocation;
} & GridPaginationProps;

export const HostEventsTable = ({ from, ...paginationProps }: Prop) => {
  const columns: GridColDef<IHostEvent>[] = [
    { field: "inviteOnly", headerName: "Invite Only", type: "boolean", hideable: false },
    {
      field: "name",
      headerName: "Event Name",
      flex: 1,
      minWidth: 350,
      renderCell: ({ row }) => (
        <Stack direction="row" spacing={1}>
          {row.inviteOnly && (
            <SMTooltip
              title={
                "This means the event is invite only. Invite only means that the event is limited by one of the following. A custom list of patrons, only patrons who have link to the mobile app, or only patrons who have not linked to the mobile app."
              }
            >
              <MailIcon />
            </SMTooltip>
          )}
          <Typography>{row.name}</Typography>
        </Stack>
      ),
    },
    { field: "categoryName", headerName: "Category", minWidth: 220 },
    {
      field: "start",
      headerName: "Start Date",
      ...dateCol,
      minWidth: 120,
      valueFormatter: ({ value }) => moment(value).format("MM/DD/YY"),
    },
    {
      field: "end",
      headerName: "End Date",
      ...dateCol,
      minWidth: 120,
      valueFormatter: ({ value }) => moment(value).format("MM/DD/YY"),
    },
    {
      field: "active",
      headerName: "Active",
      minWidth: 140,
      valueFormatter: ({ value }) => value ?? "N/A",
    },
  ];
  const navigate = useNavigate();
  const response = useHostEvents();
  const isMobile = useMobile();

  return (
    <>
      <SWRDataGrid
        name="host-player-events"
        initialState={{
          columns: {
            columnVisibilityModel: {
              inviteOnly: false,
            },
          },
          sorting: {
            sortModel: [{ field: "start", sort: "asc" }],
          },
        }}
        response={response}
        columns={columns}
        {...paginationProps}
        onRowClick={({ row }) => {
          switch (from) {
            case "dashboard":
              navigate(Routes.forHostDashboardEvent(row.orig_id));
              break;
            case "page":
              navigate(Routes.forHostEvent(row.orig_id));
              break;
          }
        }}
        slotProps={{
          filterPanel: isMobile ? filterPanelSx : undefined,
        }}
        noRowsMessage="No Events Found"
        clickableRow
      />
      <Outlet />
    </>
  );
};
